import Joi from "joi";
import errorsResolver from "../schemeUtils";
import { maxLength } from "../../helpers/data-constants";

const PAYER_NUMBER_LENGTH = 40;
const REGISTRATION_NUMBER = 30;
const REGISTERING_AUTHORITY = 300;
const ACTIVITIES = 300;
const MAX_TURNOVER = 99999999.99;

const patterns = {
  siteUrl: "^[0-9a-zA-Zа-яА-ЯёЁ\\-./:_~ ]*$",
  generalText: `^[a-zA-Zа-яА-ЯёЁ0-9() *\\/?!%{}[\\]^<>,-.|№"_=&$#~@+\'\\\\ \n\r:;«»\`]{1,${maxLength.SERVICE_INFORMATION_RISK}}$`,
  payerNumber: `^[a-zA-Zа-яА-ЯёЁ0-9\\-(), ]{1,${PAYER_NUMBER_LENGTH}}$`,
  numberOnly: '^[0-9]+$',
  registrationNumber: `^[a-zA-Zа-яА-ЯёЁ0-9\\- ]{1,${REGISTRATION_NUMBER}}$`,
  registeringAuthority: `^[-a-zA-Zа-яА-ЯёЁ0-9.(), ]{1,${REGISTERING_AUTHORITY}}$`,
  activities: `^[-a-zA-Zа-яА-ЯёЁ0-9.(), ]{1,${ACTIVITIES}}$`,
};

const errorMessages = {
  number: {
    base: "должен быть корректным числом",
    unsafe: "должен быть корректным числом",
    min: "должен быть больше нуля",
    required: "обязательное поле"
  }
};

const clientIEScheme = Joi.object({
  index: Joi.any(),
  
  siteUrl: Joi.string()
    .trim()
    .max(100)
    .allow("")
    .pattern(new RegExp(patterns.siteUrl))
    .error(
      errorsResolver({
        max: "Адрес сайта должно быть до 100 символов",
        pattern: "Адрес сайта содержит некорректные символы",
      })
    ),

  turnover: Joi.number()
    .required()
    .empty("")
    .max(MAX_TURNOVER)
    .min(1)
    .precision(2)
    .error(
      errorsResolver({
        numberBase: `Предполагаемый среднемесячный оборот ${errorMessages.number.base}`,
        numberUnsafe: `Предполагаемый среднемесячный оборот ${errorMessages.number.unsafe}`,
        numberMin: `Предполагаемый среднемесячный оборот ${errorMessages.number.min}`,
        numberMax: `Предполагаемый среднемесячный оборот должен быть меньше ${MAX_TURNOVER}`,
        required: `Предполагаемый среднемесячный оборот ${errorMessages.number.required}`,
        number: "Предполагаемый среднемесячный оборот должен быть числом",
      })
    ),

  decisionMakersInfo: Joi.string()
    .allow("")
    .max(maxLength.SERVICE_INFORMATION_RISK)
    .pattern(new RegExp(patterns.generalText))
    .error(
      errorsResolver({
        max: `Поле должно быть до ${maxLength.SERVICE_INFORMATION_RISK} символов`,
        pattern: "Поле содержит некорректные символы",
      })
    ),

  registrationNumber: Joi.string()
    .max(REGISTRATION_NUMBER)
    .pattern(new RegExp(patterns.registrationNumber))
    .required()
    .error(
      errorsResolver({
        required: `Регистрационный номер ${errorMessages.number.required}`,
        max: `Поле должно быть до ${REGISTRATION_NUMBER} символов`,
        pattern: "Поле содержит некорректные символы",
      })
    ),

  dateStateRegistration: Joi.date()
    .iso()
    .error(errorsResolver({
      dateFormat: `Некорректная дата государственной регистрации`,
    })),

  registeringAuthority: Joi.string()
    .trim()
    .max(REGISTERING_AUTHORITY)
    .pattern(new RegExp(patterns.registeringAuthority))
    .required()
    .error(
      errorsResolver({
        required: `Наименование регистрирующего органа ${errorMessages.number.required}`,
        max: `Поле должно быть до ${REGISTERING_AUTHORITY} символов`,
        pattern: "Поле содержит некорректные символы",
      })
    ),

  activities: Joi.string()
    .trim()
    .max(ACTIVITIES)
    .pattern(new RegExp(patterns.activities))
    .required()
    .error(
      errorsResolver({
        required: `Виды деятельности ${errorMessages.number.required}`,
      })
    ),

  payerNumber: Joi.string()
    .trim()
    .max(PAYER_NUMBER_LENGTH)
    .required()
    .pattern(new RegExp(patterns.payerNumber))
    .error(
      errorsResolver({
        max: `Учётный номер плательщика должен быть до ${PAYER_NUMBER_LENGTH} символов`,
        pattern: "Учётный номер плательщика содержит некорректные символы",
        required: `Учётный номер плательщика ${errorMessages.number.required}`
      })
    ),
});

export default clientIEScheme;
